import { render } from "./btcOrderCompleted.vue?vue&type=template&id=6737442a"
import script from "./btcOrderCompleted.vue?vue&type=script&lang=js"
export * from "./btcOrderCompleted.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__